import { regulationsService } from './regulationsService';

export * from './regulationsService';

export default regulationsService;
